import { render, staticRenderFns } from "./post.vue?vue&type=template&id=c2043db6&"
import script from "./post.vue?vue&type=script&lang=js&"
export * from "./post.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../themes/chop-child/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/proservdemo25/public_html/wp-content/themes/chop-child/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2043db6')) {
      api.createRecord('c2043db6', component.options)
    } else {
      api.reload('c2043db6', component.options)
    }
    module.hot.accept("./post.vue?vue&type=template&id=c2043db6&", function () {
      api.rerender('c2043db6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "plugins/MtcPostFilter/assets/components/post.vue"
export default component.exports